import { nanoid } from "nanoid";
import store from "../store";

let currentAudio = null;

const ELYXUtils = {
  playSound(sound, volume = 0.2) {
    if (currentAudio) {
      currentAudio.pause();
      currentAudio.currentTime = 0;
    }
    const audioSource = sound.default || sound;
    currentAudio = new Audio(audioSource);
    currentAudio.currentTime = 0;
    currentAudio.volume = volume;
    currentAudio.play();
  },
  /**
   * Generates a random ID usually used for placeholder ID values.
   * @returns {Number}
   */
  generateRandomID() {
    return Math.floor(Date.now() + Math.random());
  },

  getRandomStringID() {
    return nanoid();
  },

  /**
   * Escapes an input from its passed in event.
   * @param {Object} event
   */
  escapeInput(event) {
    event.target.blur();
  },

  delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  },

  /** Prevent users from mentioning our competitors or at least make it super hard */
  checkBlacklistedWords(content) {
    /**
     * Handle diacritics (accents) on letters. For instance, if someone uses
     * "fócusmate" where "ó" is an "o" with an accent, this step will normalize "ó" to "o".
     * This is especially important if you want to ensure that all versions of a word,
     * even with accents, are caught by the filter.
     */
    content = content.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

    /**
     * Convert standard LEET speak variations of "focusmate" (and potentially other words)
     * to their regular form.
     */
    function containsFocusmateVariation(str) {
      const leetReplacements = {
        f: ["ph"],
        o: ["0", "@", "2", "\\(\\)", "\\[\\]"],
        c: ["<", "\\{", "\\[", "\\("],
        u: ["v", "µ", "\\|_\\|"],
        s: ["5", "\\$", "z"],
        m: ["\\|v\\|", "/\\/\\\\", "\\^\\^"],
        a: ["4", "@", "\\^", "/\\\\"],
        t: ["7", "\\+", "1"],
        e: ["3", "€", "£"],
      };

      function buildRegexReplacements(letter) {
        return `(${leetReplacements[letter].join("|")}|${letter})`;
      }

      const focusmatePattern = `f${buildRegexReplacements("o")}${buildRegexReplacements("c")}${buildRegexReplacements("u")}${buildRegexReplacements(
        "s"
      )}m${buildRegexReplacements("a")}${buildRegexReplacements("t")}${buildRegexReplacements("e")}`;

      // Here we replace the leet speak with the standard word
      return str.replace(new RegExp(focusmatePattern, "gi"), "focusmate");
    }

    content = containsFocusmateVariation(content);

    /**
     * Replace anything that's not a letter, takes care of anyone manipulating with
     * any dashes or underscores or other symbols to get around the filter. Also removes
     * any empty spaces, including unicode spaces.
     */
    content = content.replace(/[^a-zA-Z]+/g, "");

    content = content.toLowerCase();

    const BLACKLIST = [
      "focusmate",
      "usmate",
      "usmait",
      "fokusmate",
      "focuxmate",
      "foxusmate",
      "foccusmate",
      "focosmate",
      "focusmat",
      "fcusmate",
      "fcsmt",
      "focsmate",
      "studyverse",
      "studystream",
      "focus101",
    ];
    for (let word of BLACKLIST) {
      const regex = new RegExp(word, "i"); // 'i' flag for case-insensitive match
      if (regex.test(content)) {
        alert(
          "Mentioning competitors is not allowed. Thank you for your understanding. Feel free to reach out to us at support@cofocus.one if you have any questions."
        );
        window.mixpanel.track("Attempted To Use Competitor Keyword", {
          UID: store.state.auth.user._id,
          data: JSON.stringify(content),
          page: window.location.href,
        });
        return false;
      }
    }

    /** Pass */
    return true;
  },
};

export default ELYXUtils;
